var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { RichText as ReactRichText, RichTextPropTypes, } from '@sitecore-jss/sitecore-jss-react';
export const prefetched = {};
export const RichText = (props) => {
    const { internalLinksSelector = 'a[href^="/"]', prefetchLinks = true, editable = true } = props, rest = __rest(props, ["internalLinksSelector", "prefetchLinks", "editable"]);
    const hasText = props.field && props.field.value;
    const isEditing = editable && props.field && (props.field.editable || props.field.metadata);
    const router = useRouter();
    const richTextRef = useRef(null);
    useEffect(() => {
        // NOT IN EDIT MODE
        if (hasText && !isEditing) {
            initializeLinks();
        }
    }, [hasText]);
    const routeHandler = (ev) => {
        if (!ev.currentTarget)
            return;
        ev.preventDefault();
        const pathname = ev.currentTarget.href;
        router.push(pathname, pathname, { locale: false });
    };
    const initializeLinks = () => {
        const node = richTextRef.current;
        // selects all links that start with '/'
        const internalLinks = node && node.querySelectorAll(internalLinksSelector);
        if (!internalLinks || !internalLinks.length)
            return;
        internalLinks.forEach((link) => {
            if (link.target === '_blank')
                return;
            const prefetch = () => {
                router.prefetch(link.pathname, undefined, { locale: false });
                prefetched[link.pathname] = true;
            };
            if (!prefetched[link.pathname] && prefetchLinks !== false) {
                if (prefetchLinks === true) {
                    prefetch();
                }
                if (prefetchLinks === 'hover') {
                    const mouseOverHandler = () => {
                        prefetch();
                        link.removeEventListener('mouseover', mouseOverHandler);
                    };
                    link.addEventListener('mouseover', mouseOverHandler, false);
                }
            }
            link.addEventListener('click', routeHandler, false);
        });
    };
    return React.createElement(ReactRichText, Object.assign({ ref: richTextRef, editable: editable }, rest));
};
RichText.propTypes = Object.assign({ internalLinksSelector: PropTypes.string }, RichTextPropTypes);
RichText.displayName = 'NextRichText';
